module.exports = __webpack_public_path__ + "static/media/Request.c25504c5.svg";